<template>
  <v-container
    style="width: 50px"
  >
    <v-btn
      id="account"
      class="px-3"
      text
      min-width="40"
      @click="showLogin"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      activator="#account"
      bottom
      content-class="v-account"
      left
      nudge-left="30"
      offset-x
    >
      <v-card
        class="text-center mb-0"
        width="300"
        height="400"
      >
        <v-card-text>
          <br>
          <strong class="mb-3 d-inline-block">Sign up</strong>
          <v-divider class="my-4 secondary" />
          <div id="firebaseui-auth-container" />
          <div id="loader">
            Loading...
          </div>
          <v-divider class="my-4 secondary" />
        </v-card-text>

        <!-- <v-card-text>
          <strong class="mb-3 d-inline-block">Color Setting</strong>

          <v-item-group v-model="color">
            <v-item
              v-for="color in colors"
              :key="color"
              :value="color"
            >
              <template v-slot="{ active, toggle }">
                <v-avatar
                  :class="active && 'v-settings__item--active'"
                  :color="color"
                  class="v-settings__item"
                  size="25"
                  @click="toggle"
                />
              </template>
            </v-item>
          </v-item-group>

        </v-card-text> -->
      </v-card>
    </v-menu>
  </v-container>
</template>

<script>
  import * as firebaseui from 'firebaseui'
  import firebase from 'firebase/app'
  import 'firebaseui/dist/firebaseui.css'
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  export default {
    name: 'DashboardRegister',

    mixins: [Proxyable],

    data: () => ({
      menu: false,
    }),

    methods: {
      showLogin () {
        var uiConfig = {
          callbacks: {
            signInSuccessWithAuthResult: function (authResult, redirectUrl) {
              // User successfully signed in.
              // Return type determines whether we continue the redirect automatically
              // or whether we leave that to developer to handle.
              return true
            },
            uiShown: function () {
              // The widget is rendered.
              // Hide the loader.
              document.getElementById('loader').style.display = 'none'
            },
          },
          // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
          signInFlow: 'popup',
          signInSuccessUrl: 'http://localhost:8080/',
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            // firebase.auth.GithubAuthProvider.PROVIDER_ID,
            // firebase.auth.EmailAuthProvider.PROVIDER_ID,
            // firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          ],
          // Terms of service url.
          tosUrl: 'http://localhost:8080/',
          // Privacy policy url.
          privacyPolicyUrl: 'http://localhost:8080/',
        }
        const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
        window.setTimeout(function () {
          ui.start('#firebaseui-auth-container', uiConfig)
        }, 500)
      },
    },
  }
</script>
